import Header from "../../components/User/Header";
import { Box, Container, Typography, Button, Card, CardContent } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const Result = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/home");
  };

  const handleReport = () => {
    navigate("/report"); // Navigate to your Report page route
  };

  // Find the item with the highest match score
  const bestMatch =
    state?.matches?.length > 0
      ? state.matches.reduce((prev, current) =>
          current.final_score > prev.final_score ? current : prev
        )
      : null;

  return (
    <Box sx={{ bgcolor: "#FBFFE9", minHeight: "100vh", width: "100%" }}>
      <Header />

      <Container sx={{ py: 5 }}>
        {/* Back Button */}
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{
            bgcolor: "#344b35",
            '&:hover': { bgcolor: "#516d4f" },
            textTransform: "none",
            fontWeight: "bold",
            py: 1.5,
            borderRadius: "12px",
            mb: 4,
          }}
        >
          ← Back to Home
        </Button>

        {bestMatch ? (
          <>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "#2e4630" }}>
              Top Match
            </Typography>

            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 3,
                bgcolor: "#f4f9ec",
                border: "1px solid #c7dfb7",
                transition: "0.3s",
                "&:hover": {
                  transform: "scale(1.02)",
                  boxShadow: 6,
                },
                mb: 4,
              }}
            >
              <CardContent>
                <Typography variant="h6" sx={{ color: "#344b35", fontWeight: "bold", mb: 1 }}>
                  {bestMatch.item_name}{" "}
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{ color: "#607d3b" }}
                  >
                    ({bestMatch.item_type})
                  </Typography>
                </Typography>
                <Typography>
                  Brand: <strong>{bestMatch.brand_model}</strong>
                </Typography>
                <Typography>
                  Color: <strong>{bestMatch.color}</strong>
                </Typography>
                <Typography>
                  Found at: <strong>{bestMatch.location_found}</strong> on{" "}
                  <strong>{bestMatch.date_found}</strong>
                </Typography>
                <Typography>
                  Condition: <strong>{bestMatch.item_condition}</strong>
                </Typography>
                <Typography sx={{ mt: 1 }} variant="caption" color="text.secondary">
                  Match Score: {bestMatch.final_score.toFixed(2)}%
                </Typography>
              </CardContent>
            </Card>

            <Button
              variant="outlined"
              onClick={handleReport}
              sx={{
                borderColor: "#344b35",
                color: "#344b35",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "12px",
                px: 4,
                py: 1.5,
                '&:hover': {
                  bgcolor: "#e5f0dc",
                  borderColor: "#516d4f",
                }
              }}
            >
              Report This Item
            </Button>
          </>
        ) : (
          <Typography variant="h5" sx={{ color: "#c74f4f", mt: 25, textAlign: "center" }}>
            No matches found.
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default Result;